import "./about.css";

import React from "react";

import { ABOUT } from "../../data/content";
import PageMeta from "../general/PageMeta";
import PageTitle from "../general/PageTitle";

const About = () => {
  return (
    <div className={"page"}>
      <PageMeta
        title={"About"}
        description={"The Charles Greig Gallery opened in 2014 at Hyde Park Corner, Johannesburg, downstairs from the Charles Greig flagship store - a space for bronze wildlife sculpture and Ardmore ceramic art."}
      />
      <PageTitle>{ABOUT.PAGE_TITLE}</PageTitle>

      <div className={"container"}>
        <section className={"title-box"}>
          <h2 className={"section-title"}>{ABOUT.TITLE}</h2>
          <div className={"about-intro"}>
            {ABOUT.INTRO.map((text) => (
              <p
                key={text}
                className={"body-text is-justified"}
              >
                {text}
              </p>
            ))}
          </div>
        </section>

        {ABOUT.SECTIONS.map((section, i) => (
          <section
            key={section.image.src}
            className={`split-row ${i % 2 ? "is-reversed" : ""}`}
          >
            <div className={"split-text"}>
              <p className={"body-text is-justified"}>{section.text}</p>
            </div>
            <div className={"split-photo"}>
              <img
                className={"shadow-photo"}
                src={section.image.src}
                alt={section.image.alt}
                loading={"lazy"}
                width={446}
                height={610}
              />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default About;
